<template>
	<b-modal
		ref="depurations-detail-modal"
		:title="`Motivos de depuración`"
		size="xlg"
		centered
		hide-footer
		scrollable
		@hidden="handleHidden"
	>
		<b-overlay :show="isLoading">
			<h5 class="text-uppercase">
				Total de depurados:
				<span class="text-primary">
					{{ totalDepu }}
				</span>
			</h5>
			<VueApexCharts type="pie" height="400" :options="chartOpts" :series="chartData" />
		</b-overlay>
	</b-modal>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import posturaService from "@/services/posturas.service"

export default {
	components: { VueApexCharts },
	props: {
		startDate: { type: String, required: false, default: null },
		endDate: { type: String, required: false, default: null },
		specimenId: { type: Number, required: false, default: null },
		selectedPostura: { type: Object, required: false, default: null },
		totalDepu: { required: true },
	},
	data: () => ({
		isLoading: false,
		chartData: [1],
		chartOpts: {
			labels: ["base"],
		},
		selectedReason: null,
		reasons: [],
	}),
	async mounted() {
		await this.getReasonsReport()
		this.$refs["depurations-detail-modal"].toggle()
	},
	computed: {},
	methods: {
		handleHidden() {
			this.isLoading = false
			this.$emit("close")
		},
		async getReasonsReport() {
			try {
				const data = await posturaService.getReasonsForDepurationByPosture({
					specimen_id: this.selectedPostura ? null : this.specimenId,
					start_date: this.selectedPostura ? null : this.startDate,
					end_date: this.selectedPostura ? null : this.endDate,
					postura_id: this.selectedPostura ? this.selectedPostura.postura_id : null,
				})
				const qtys = []
				const labels = []
				data.sort((a, b) => Number(b.qty) - Number(a.qty))
				data.forEach((data) => {
					qtys.push(Number(data.qty))
					labels.push(String(data.reason ?? "Sin motivo").toUpperCase())
				})
				this.reasons = data
				this.chartData = qtys
				this.chartOpts = {
					chart: {
						type: "pie",
					},
					labels,
					dataLabels: {
						formatter: function (value, { seriesIndex }) {
							return `${Number(value).toFixed(1)}%=${qtys[seriesIndex]}`
						},
						style: { colors: ["#fff"] },
					},
					legend: {
						formatter: function (seriesName, opts) {
							return [seriesName, " : ", opts.w.globals.series[opts.seriesIndex]]
						},
					},
				}
			} catch (error) {
				console.log("errorr: ", error)
			} finally {
				this.isLoading = false
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.underline-hover {
	text-decoration: underline;
	transition: all 0.1s ease;
}
.underline-hover:hover {
	font-weight: bold;
	cursor: pointer;
	font-size: 1.2rem;
}
</style>
